import type { BlockType } from "../types";
import { ReaderLayoutContainerPropsSchema, ReaderLayoutLinkPropsSchema, ReaderLayoutModalPropsSchema } from "./props";

export const ContainerBlockDefs = {
  ReaderLayoutModal: {
    type: "ReaderLayoutModal",
    label: "Layout Modal",
    allowedRegions: [
      "topBar",
      "leftBar",
      "leftDrawer", 
      "rightBar",
      "rightDrawer", 
      "bottomBar", 
      "bottomDrawer", 
      "modal"
    ],
    allowedChildren: [
      "ReaderLayoutContainer",
      "ReaderLayoutLink",
      "ReaderLayoutTableOfContents",
      "ReaderLayoutSettings",
      "ReaderLayoutButton",
      "ReaderLayoutImage",
      "ReaderLayoutLabel",
      "ReaderLayoutInput",
      "ReaderLayoutProgressSlider",
      "ReaderLayoutReadAloudButton", 
    ] as const satisfies readonly BlockType[],
    propsSchema: ReaderLayoutModalPropsSchema,
    componentName: "ReaderLayoutModal",
  },
  ReaderLayoutContainer: {
    type: "ReaderLayoutContainer",
    label: "Layout Container",
    allowedRegions: [
      "topBar",
      "leftBar",
      "leftDrawer", 
      "rightBar",
      "rightDrawer", 
      "bottomBar", 
      "bottomDrawer", 
      "modal"
    ],
    allowedChildren: [
      "ReaderLayoutContainer",
      "ReaderLayoutLink",
      "ReaderLayoutTableOfContents",
      "ReaderLayoutSettings",
      "ReaderLayoutButton",
      "ReaderLayoutImage",
      "ReaderLayoutLabel",
      "ReaderLayoutInput",
      "ReaderLayoutProgressSlider",
      "ReaderLayoutReadAloudButton", 
    ] as const satisfies readonly BlockType[],
    propsSchema: ReaderLayoutContainerPropsSchema,
    componentName: "ReaderLayoutContainer",
  },
  ReaderLayoutLink: {
    type: "ReaderLayoutLink",
    label: "Link",
    allowedRegions: [
      "topBar",
      "leftBar",
      "leftDrawer", 
      "rightBar",
      "rightDrawer", 
      "bottomBar", 
      "bottomDrawer", 
      "modal"
    ],
    allowedChildren: [
      "ReaderLayoutImage",
      "ReaderLayoutLabel",
      "ReaderLayoutButton",
    ] as const satisfies readonly BlockType[],
    propsSchema: ReaderLayoutLinkPropsSchema,
    componentName: "ReaderLayoutLink",
  }
} as const;